import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export function exportToXlsx(rows, filename, sheetName = 'Sheet1') {
  const ws = XLSX.utils.json_to_sheet(rows);
  const keys = Object.keys(rows[0] || {});
  ws['!cols'] = keys.map(key => ({ wch: rows.reduce((width, row) => Math.min(45, Math.max(width, String(row[key] ?? '').length + 2)), key.length + 2) }));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([buf], { type: 'application/octet-stream' }), filename);
}

export function exportToCsv(rows, filename) {
  const safeRows = rows.map(row => Object.fromEntries(Object.entries(row).map(([key, value]) => [key, typeof value === 'string' && /^[=+@\-\t\r]/.test(value) ? `'${value}` : value])));
  const ws = XLSX.utils.json_to_sheet(safeRows);
  const csv = XLSX.utils.sheet_to_csv(ws);
  saveAs(new Blob(['\ufeff', csv], { type: 'text/csv;charset=utf-8;' }), filename);
}
